(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initTypewriter = (root) => {
    const word = root.querySelector('[data-lc-typewriter]');
    if (!word || reduceMotion.matches) return;
    window.requestAnimationFrame(() => {
      word.classList.add('is-typing');
    });
  };

  const initCarousel = (carousel) => {
    const track = carousel.querySelector('[data-lc-slides]');
    const slides = Array.from(carousel.querySelectorAll('[data-lc-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-lc-dot]'));
    const previous = carousel.querySelector('[data-lc-prev]');
    const next = carousel.querySelector('[data-lc-next]');
    if (!track || slides.length < 2) return;

    let activeIndex = 0;
    let autoplay;
    let scrollTimer;
    const imageDelay = 3400;
    const videoDelay = 6200;

    const updateDots = () => {
      dots.forEach((dot, index) => {
        if (index === activeIndex) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const syncVideos = () => {
      slides.forEach((slide, index) => {
        const video = slide.querySelector('[data-lc-video]');
        if (!video) return;

        if (index === activeIndex && !reduceMotion.matches && !document.hidden) {
          video.play().catch(() => {});
        } else {
          video.pause();
          if (index !== activeIndex) video.currentTime = 0;
        }
      });
    };

    const goTo = (index, smooth = true) => {
      activeIndex = (index + slides.length) % slides.length;
      track.scrollTo({
        left: slides[activeIndex].offsetLeft,
        behavior: smooth && !reduceMotion.matches ? 'smooth' : 'auto'
      });
      updateDots();
      syncVideos();
    };

    const stop = () => window.clearTimeout(autoplay);
    const start = () => {
      stop();
      syncVideos();
      if (reduceMotion.matches || document.hidden) return;
      const delay = slides[activeIndex].querySelector('[data-lc-video]') ? videoDelay : imageDelay;
      autoplay = window.setTimeout(() => {
        goTo(activeIndex + 1);
        start();
      }, delay);
    };

    previous?.addEventListener('click', () => {
      goTo(activeIndex - 1);
      start();
    });
    next?.addEventListener('click', () => {
      goTo(activeIndex + 1);
      start();
    });
    dots.forEach((dot, index) => dot.addEventListener('click', () => {
      goTo(index);
      start();
    }));

    track.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => {
        const nextIndex = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        const normalizedIndex = Math.min(Math.max(nextIndex, 0), slides.length - 1);
        const changed = normalizedIndex !== activeIndex;
        activeIndex = normalizedIndex;
        updateDots();
        if (changed) start();
      }, 80);
    }, { passive: true });

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', start);
    reduceMotion.addEventListener?.('change', start);
    updateDots();
    start();
  };

  const init = (root) => {
    if (root.dataset.lcInfaltablesReady === 'true') return;
    root.dataset.lcInfaltablesReady = 'true';
    initTypewriter(root);
    root.querySelectorAll('[data-lc-carousel]').forEach(initCarousel);
  };

  document.querySelectorAll('[data-lc-infaltables]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-lc-infaltables]').forEach(init);
  });
})();
